import React from 'react';
import PropTypes from 'prop-types';

class ListItem extends React.Component {
  getUrl() {
    const { slug, type } = this.props;
    switch (type) {
      case 'organization':
        return `/organizations/${slug}`;
      case 'portal':
        return `/portals/${slug}`;
      case 'brandguide':
        return `https://brandguide.brandfolder.com/${slug}`;
      default:
        return `/${slug}`;
    }
  }

  renderCollectionsPrivacyIcon() {
    const { publicPrivacy, stealthPrivacy } = this.props;
    if (publicPrivacy === true && stealthPrivacy === false) {
      return (
        <div className="privacy-pill">
          <div className="circle public" />
          <span className="bff-public" aria-hidden />
        </div>
      );
    }
    if (publicPrivacy === false && stealthPrivacy === false) {
      return (
        <div className="privacy-pill">
          <div className="circle private" />
          <span className="bff-private" aria-hidden />
        </div>
      );
    }
    if (publicPrivacy === false && stealthPrivacy === null) {
      return (
        <div className="privacy-pill">
          <div className="circle private" />
          <span className="bff-private" aria-hidden />
        </div>
      );
    }
    return (
      <div className="privacy-pill">
        <div className="circle stealth" />
        <span className="bff-stealth" aria-hidden />
      </div>
    );
  }

  render() {
    const { name, type } = this.props;

    return (
      <li
        className={`search-dropdown__item search-dropdown__item--${type}`}
        data-testid="search-dropdown-list-item"
      >
        {`${type}` === 'brandfolder'
          && <span className={`bff-grid-view search-dropdown__item--${type}--icon`} aria-hidden />
        }
        {`${type}` === 'brandguide'
          && <span className={`bff-brand-guide search-dropdown__item--${type}--icon`} aria-hidden />
        }
        {`${type}` === 'portal'
          && <span className={`bff-portal search-dropdown__item--${type}--icon`} aria-hidden />
        }
        <a
          href={this.getUrl()}
          data-testid="search-dropdown-list-item-link"
          aria-label={`${name} ${type}`}
        >
          {`${type}` === 'collections' && this.renderCollectionsPrivacyIcon()}
          <span>{name}</span>
        </a>
        {`${type}` === 'organization'
          && <span className="org-label" data-testid="search-dropdown-org-label" aria-hidden>Org</span>
        }
      </li>
    );
  }
}

ListItem.propTypes = {
  name: PropTypes.string.isRequired,
  publicPrivacy: PropTypes.bool,
  slug: PropTypes.string.isRequired,
  stealthPrivacy: PropTypes.bool,
  type: PropTypes.oneOf([
    'organization',
    'brandfolder',
    'collections',
    'portal',
    'brandguide',
  ]).isRequired
};

ListItem.defaultProps = {
  publicPrivacy: true,
  stealthPrivacy: false
};

export default ListItem;
